import React from "react";

const services = [
  {
    title: "Wedding Transport",
    detail:
      "Premium buses for baraat, guests, and venue-to-venue movement with coordinated timings.",
  },
  {
    title: "Family Trips",
    detail:
      "Comfortable AC coaches for weekend getaways, temple visits, and leisure tours.",
  },
  {
    title: "Picnic & Outing",
    detail:
      "Reliable pickup and drop for school, college, and corporate day-outs.",
  },
  {
    title: "Corporate Travel",
    detail:
      "Safe and punctual transport for office commutes, events, and conferences.",
  },
  {
    title: "Airport Pickup",
    detail:
      "On-time airport transfers with space for luggage and flexible schedules.",
  },
  {
    title: "Tour Packages",
    detail:
      "Custom itineraries with experienced drivers and route planning support.",
  },
];

const highlights = [
  "AC and non-AC options with clean interiors",
  "Experienced drivers and verified vehicles",
  "Flexible timings and transparent pricing",
  "Support for short and long-distance trips",
];

const BusRent = () => {
  return (
    <section className="bg-bg-white">
      <div className="max-w-7xl mx-auto px-6 pt-20 pb-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 items-center">
          <div>
            <p className="text-sm tracking-[0.2em] uppercase text-orange-main font-semibold">
              Bus On Rent
            </p>
            <h1 className="text-4xl md:text-5xl font-semibold leading-tight text-black-custom mt-4">
              Modern, organized bus rental service for every occasion
            </h1>
            <p className="text-lg text-gray-dark mt-5 leading-relaxed">
              We provide buses on rent for wedding functions, family trips,
              picnics, corporate travel, and more. Our fleet is maintained to
              deliver comfort, safety, and on-time service across all routes.
            </p>

            <div className="mt-8 grid grid-cols-1 sm:grid-cols-2 gap-3 text-[#3b332d]">
              {highlights.map((item) => (
                <div
                  key={item}
                  className="bg-white rounded-xl px-4 py-3 shadow-sm border border-orange-light/20"
                >
                  {item}
                </div>
              ))}
            </div>
          </div>

          <div className="bg-gradient-to-br from-orange-main to-teal-main rounded-[28px] p-8 text-white shadow-[0_30px_70px_rgba(217,116,42,0.2)]">
            <h2 className="text-2xl font-semibold">Our Bus Rent Services</h2>
            <p className="text-sm text-white/80 mt-2">
              Choose the right service for your travel requirement.
            </p>
            <div className="mt-6 grid grid-cols-1 gap-4">
              {services.map((service) => (
                <div
                  key={service.title}
                  className="bg-white/10 border border-white/20 rounded-2xl p-4"
                >
                  <h3 className="text-lg font-semibold">{service.title}</h3>
                  <p className="text-sm text-white/80 mt-1">{service.detail}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-6 pb-20">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 items-stretch">
          <div className="bg-white rounded-[28px] p-8 shadow-[0_24px_60px_rgba(0,0,0,0.12)] border border-orange-light/20">
            <h2 className="text-3xl font-semibold text-black-custom">
              Quick Bus Rent Query
            </h2>
            <p className="text-sm text-gray-dark mt-2">
              Share your travel needs and we will get back with the best option.
            </p>

            <form className="mt-8 grid grid-cols-1 gap-5">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
                <input
                  className="w-full rounded-xl border border-[#eadfd4] bg-[#fffaf6] px-4 py-3 text-[#3b332d] outline-none focus:border-[#b34a1d]"
                  placeholder="Full Name"
                  type="text"
                />
                <input
                  className="w-full rounded-xl border border-[#eadfd4] bg-[#fffaf6] px-4 py-3 text-[#3b332d] outline-none focus:border-[#b34a1d]"
                  placeholder="Phone Number"
                  type="tel"
                />
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
                <select className="w-full rounded-xl border border-[#eadfd4] bg-[#fffaf6] px-4 py-3 text-[#3b332d] outline-none focus:border-[#b34a1d]">
                  <option>Bus Type</option>
                  <option>Mini Bus</option>
                  <option>AC Coach</option>
                  <option>Non-AC Coach</option>
                  <option>Luxury Bus</option>
                </select>
                <input
                  className="w-full rounded-xl border border-[#eadfd4] bg-[#fffaf6] px-4 py-3 text-[#3b332d] outline-none focus:border-[#b34a1d]"
                  placeholder="Number of People"
                  type="number"
                  min="1"
                />
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
                <select className="w-full rounded-xl border border-[#eadfd4] bg-[#fffaf6] px-4 py-3 text-[#3b332d] outline-none focus:border-[#b34a1d]">
                  <option>Function Type</option>
                  <option>Wedding</option>
                  <option>Family Trip</option>
                  <option>Picnic</option>
                  <option>Corporate</option>
                  <option>Other</option>
                </select>
                <input
                  className="w-full rounded-xl border border-[#eadfd4] bg-[#fffaf6] px-4 py-3 text-[#3b332d] outline-none focus:border-[#b34a1d]"
                  type="date"
                />
              </div>

              <textarea
                className="w-full rounded-xl border border-[#eadfd4] bg-[#fffaf6] px-4 py-3 text-[#3b332d] outline-none focus:border-[#b34a1d] resize-none"
                rows="4"
                placeholder="Pickup location, destination, and special notes"
              />

              <button className="bg-orange-main hover:opacity-90 transition text-white px-6 py-3 rounded-full font-semibold w-full md:w-fit">
                Send Query
              </button>
            </form>
          </div>

          <div className="bg-gradient-to-br from-orange-light/10 to-teal-light/10 rounded-[28px] p-8 border border-orange-light/20 flex flex-col justify-between">
            <div>
              <p className="text-sm uppercase tracking-[0.25em] text-orange-main font-semibold">
                Why Choose Us
              </p>
              <h3 className="text-2xl font-semibold text-black-custom mt-4">
                Clean buses, trusted drivers, on-time service
              </h3>
              <p className="text-gray-dark mt-3 leading-relaxed">
                We plan routes carefully, share transparent pricing, and provide
                the right vehicle as per your group size and event type.
              </p>
            </div>
            <div className="mt-6 grid grid-cols-1 gap-4">
              {highlights.map((item) => (
                <div
                  key={item}
                  className="rounded-xl bg-white/80 border border-white/60 px-4 py-3 text-black-custom shadow-sm"
                >
                  {item}
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BusRent;
